import { useEffect, useRef, useState } from 'react'
import './searchbox.scss'
import { Product } from '../../interface/interfaces'
import { BoxIcon } from 'lucide-react'
import { AnimatePresence, motion } from 'framer-motion'
import SearchBoxSkeleton from '../SkeletonLoaders/SearchBoxSkeleton'
import { searchProducts } from '../../api/requests'
import { useNotification } from '../../context/NotificationContext'
import { useLocation, useNavigate } from 'react-router-dom'
import { NavLink } from 'react-router-dom'

type Prop = {
    searchQuery: string
}

const SearchBox = ({ searchQuery }: Prop) => {
    const navigate = useNavigate()
    const location = useLocation();
    
    const [products, setProducts] = useState<Product[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const { notify } = useNotification()
    const [toggle, setToggle] = useState(false)


    const searchBox = useRef<HTMLDivElement>(null)

    useEffect(() => {

        
        const isProductsRoute = location.pathname.includes('/products');

        const initFunc = async () => {

            if (!isProductsRoute) {
                if (searchQuery !== '') {
                    setToggle(true)
                    try {
                        setIsLoading(true)
                        setProducts([])


                        let { products } = await searchProducts(searchQuery, 1, 10)
                        setProducts(products)

                    } catch (error: any) {
                        notify.error(error.message)
                    } finally {
                        setIsLoading(false)
                    }
                } else {
                    setToggle(false)
                }
            }

        }


        initFunc()
        // eslint-disable-next-line 
    }, [searchQuery])


    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                toggle &&
                searchBox.current &&
                !searchBox.current.contains(event.target as Node)) {

                setToggle(false)
            }

        }


        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [toggle]);



    const handleSearch = async () => {
      
        navigate(`/products?search=${searchQuery}`)
    }




    return (
        <>
            <AnimatePresence>
                {toggle && (

                    <div className="searchbox" ref={searchBox}>

                        {!isLoading && (<motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0 }}
                            transition={{
                                duration: 0.3,
                                ease: 'easeOut',
                                type: 'tween',
                            }}
                        >

                            {products.length >= 1 && (<div className='resultList'>
                                {products.map((data, index) => (
                                    <NavLink to={`/product/${data.productId}`}>
                                        <div className="product-info" key={index}>

                                            <div className='imageBox'>
                                                {data.imgUrl && (<img src={data.imgUrl} className='image' alt='Product'></img>)}
                                                {(!data.imgUrl || data.imgUrl === '') && (<BoxIcon size={40} strokeWidth={1} color='var(--gray-one)'></BoxIcon>)}
                                            </div>

                                            <div className='textcontent'>

                                                <div className='productname'>{data.name}</div>

                                                <div className='props'>
                                                    {/* <div className="propFlex">
                                <div className='eachprop'>
                                    <span className='proptitle'>Qty:</span>
                                    <div className="rcartprop">
                                        <span className="eachSize">{data.quantity}</span>
                                    </div>

                                </div>
                                {data.selectedProperties?.map((data, index) => (
                                    <div className='eachprop' key={index}>
                                        <span className='proptitle'>{data.name}:</span>
                                        <RenderCartProp type={data.type} value={data.value}></RenderCartProp>
                                    </div>
                                ))}
                            </div> */}
                                                    <div className='price'>{data.price_data.currency_symbol}{(data.price_data.current_price).toLocaleString()}</div>
                                                    {/* <div className='eachprop'> <span className='proptitle'>Color:</span> <span className='propvalue'>Black</span> </div> */}
                                                </div>

                                            </div>

                                        </div>
                                    </NavLink>

                                ))}

                                <div className='cpp'>
                                    <div className='clbtn' onClick={handleSearch}>See more</div>
                                </div>

                            </div>)}

                            {products.length <= 0 && (
                                <div className='emptycont'>
                                    <div className='centerb'>
                                        <BoxIcon stroke='rgba(217, 217, 217, 1)' strokeWidth={2} size={30} ></BoxIcon>
                                    </div>

                                    <div className='centerText'>No Matches</div>

                                </div>
                            )}
                        </motion.div>)}



                        {isLoading && (<SearchBoxSkeleton></SearchBoxSkeleton>)}


                    </div>

                )}
            </AnimatePresence>
        </>
    )
}

export default SearchBox